import { PageSection } from '@/features/jobs/details/components/PageLayout'
import { SectionHeadline } from '@/components/SectionHeadline'
import {
  Card,
  CardContent,
  CardContentDecoration,
  CardSubtitle,
  CardContentFooterActions,
  CardTitle,
} from '@/components/Card'
import { Avatar } from '@/components/Avatar'
import { AvatarStrip } from '@/components/AvatarStrip'
import { StyledLink } from '@/components/Link'
import { externalLinks } from '@/utils/link'
import avatar1 from '@/assets/avatars/avatar-stock1.png'
import avatar2 from '@/assets/avatars/avatar-megan.png'
import avatar3 from '@/assets/avatars/avatar-kurk.png'

const supportAvatars = [avatar1, avatar2, avatar3]

interface SupportSectionProps {
  onContactSupportPress?: () => unknown
  /**
   * Test ID attribute.
   */
  testId?: string
  /**
   * Test ID attribute for the contact support link.
   */
  contactSupportLinkTestId?: string
}

/**
 * Support section.
 */
export function SupportSection({
  onContactSupportPress,
  testId,
  contactSupportLinkTestId,
}: SupportSectionProps) {
  return (
    <PageSection>
      <SectionHeadline>Support</SectionHeadline>
      <Card testId={testId}>
        <CardContent>
          <CardContentDecoration>
            <AvatarStrip>
              {supportAvatars.map((avatarUrl, index) => (
                <Avatar
                  key={index}
                  ring
                  size={index % 2 === 0 ? 40 : 48}
                  subject={{ avatarUrl, displayName: 'Support rep' }}
                />
              ))}
            </AvatarStrip>
          </CardContentDecoration>
          <CardTitle>Still need help or are confused?</CardTitle>
          <CardSubtitle>Customer success agents available</CardSubtitle>
          <CardContentFooterActions>
            <StyledLink
              onPress={onContactSupportPress}
              testId={contactSupportLinkTestId}
              {...(!onContactSupportPress && {
                target: '_blank',
                href: externalLinks.contactSupport(),
              })}
            >
              Contact support
            </StyledLink>
          </CardContentFooterActions>
        </CardContent>
      </Card>
    </PageSection>
  )
}
